import { RESET } from '../../constants';
import { SET_CARD } from './constants';
import valueReducer from '../../../../common/reducers/valueReducer';

const card = valueReducer(null, SET_CARD, RESET);

export default card;
